module.exports = __webpack_public_path__ + "static/img/uxdesignmobile.3c52d53.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/Cattle/uxdesignmobile.png
// module id = CHoQ
// module chunks = 0